/**
 * Keeps track of all the variants that can be used.
 */
export const variants = new Map();
